import script from "./Announcements.vue?vue&type=script&setup=true&lang=js"
export * from "./Announcements.vue?vue&type=script&setup=true&lang=js"

import "./Announcements.vue?vue&type=style&index=0&id=2b97c162&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2b97c162"]])

export default __exports__